module.exports = function isNode(obj){return !!(obj && obj.nodeType == 1);};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isNode.js
 ** module id = 19
 ** module chunks = 0
 **/